export const PLUGIN_ID = 'map-box';
